import { render } from "./WeaponSelect.vue?vue&type=template&id=52cbcd47&scoped=true&ts=true"
import script from "./WeaponSelect.vue?vue&type=script&lang=ts"
export * from "./WeaponSelect.vue?vue&type=script&lang=ts"

import "./WeaponSelect.vue?vue&type=style&index=0&id=52cbcd47&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52cbcd47"]])

export default __exports__